import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_CREATIVES_LINK = Symbol('affiliate.creatives-link');
export const AFFILIATE_CREATIVES_LINK_ROUTE_NAME = Symbol('affiliate.creatives-link');
export const AFFILIATE_CREATIVES_LINK_FORM_ROUTE_NAME = Symbol('affiliate.creatives-link.form');

export const LOAD_CONDITION_TYPE_OF_TRANSACTION_QUERY_KEY = 'load-condition-type-of-transaction';
export const LOAD_CONDITION_TYPE_OF_TRANSACTION_API_URL = 'affiliate/get_creative_links/load_condition_type_of_transaction';

export const LOAD_TRACKERS_FILTER_QUERY_KEY = 'load-trackers-filter';
export const LOAD_TRACKERS_FILTER_API_URL = 'affiliate/get_creative_links/load_trackers_filter';

export const LOAD_FORMAT_FOR_CREATIVE_QUERY_KEY = 'load-format-for-creative';
export const LOAD_FORMAT_FOR_CREATIVE_API_URL = 'affiliate/get_creative_links/load_format_of_creative ';

export const LOAD_CREATIVE_LANGUAGE_QUERY_KEY = 'load-creative-language';
export const LOAD_CREATIVE_LANGUAGE_API_URL = 'affiliate/get_creative_links/load_creative_language';

export const LOAD_CREATIVE_RESOLUTION_QUERY_KEY = 'load-creative-resolution';
export const LOAD_CREATIVE_RESOLUTION_API_URL = 'affiliate/get_creative_links/load_creative_resolution';

export const LOAD_CREATIVE_ADVERTISING_COMPANY_QUERY_KEY = 'load-creative-advertising-company';
export const LOAD_CREATIVE_ADVERTISING_COMPANY_API_URL = 'affiliate/get_creative_links/load_creative_advertising_company';

export const CREATIVES_LINK_PERMISSIONS = {
  SHOW: new Permission(undefined, PermissionsList.affiliate.GETCREATIVELINKS_GET_LINK),
};
